<div *ngIf="product">
  <div class="card">
    <div class="product-img">
      <img [src]="product.defaultImage | thumb:400:80" class="card-img-top rounded m-0" loading="lazy" />
      <img src="/assets/circle-shield.svg" class="circle-shield" style="max-width: 44.25px" />
    </div>

    <div class="card-body p-1 position-relative">
      <p class="card-text m-0"><i class="fa fa-map-marker"></i> {{ product.formatedCity() }}</p>

      <h5 class="card-title m-0 mt-2">{{ product.title }}</h5>
      <p class="lot-number m-0"><small class="lot-label">LOTE:</small><br><strong>{{ product.number }}</strong></p>
      <p class="total-price m-0" *ngIf="!product.sold && !!product.totalValue"><small style="font-size: 12px; font-weight: bold;">{{ product.valueTitle }}:</small></p>
      <p class="total-price m-0" *ngIf="!product.sold && !!product.totalValue && product.saleType !== 'pre-bid'">{{ product.totalValue | currency: translations.currency }}</p>
      <p class="total-price m-0" *ngIf="!product.sold && !!product.totalValue && product.saleType === 'pre-bid'">{{ product.value | currency: translations.currency }} <small style="font-size: 14px;color: gray;font-weight: normal;" *ngIf="product.captation > 1">x{{ product.captation }} = {{ product.totalValue | currency: translations.currency }}</small></p>
      <p class="total-price m-0" *ngIf="!product.sold && !!product.totalValue"></p>
      <p class="total-price m-0" *ngIf="!product.sold && !product.totalValue">{{ translations.to_consult }}</p>
      <p class="installment-price" *ngIf="!product.sold" [innerHTML]="product.paymentConditions"></p>
      <p class="total-price m-0" *ngIf="product.sold || (product.saleType === 'pre-bid' && product.preBidClosed)">
        <button class="btn btn-primary w-100 btn-negotiate mt-4 is-sold" disabled>
          <ng-container *ngIf="product.sold">
            {{ translations.sold }}
          </ng-container>
          <ng-container *ngIf="!product.sold && product.saleType === 'pre-bid' && product.preBidClosed">
            {{ translations.pre_bid_closed }}
          </ng-container>
        </button>
      </p>
      <!-- <img src="/assets/frete.svg" class="img-frete" style="max-width: 44.25px" /> -->
    </div>
  </div>
</div>
